// @ts-nocheck
import { createFromProduct } from "@insite/client-framework/Common/ProductInfo";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { executeAwaitableHandlerChain } from "@insite/client-framework/HandlerCreator";
import { GetProductVariantChildApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import {
    chain,
    LoadInventory as BaseLoadInventory,
    RequestDataFromApi as BaseRequestDataFromApi,
    RequestVariantChildrenFromApi as BaseRequestVariantChildrenFromApi,
} from "@insite/client-framework/Store/Components/ProductSelector/Handlers/SetProduct";
import loadProduct from "@insite/client-framework/Store/Data/Products/Handlers/LoadProduct";
import loadProducts from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";
import loadVariantChild from "@insite/client-framework/Store/Data/Products/Handlers/LoadVariantChild";
import loadVariantChildren from "@insite/client-framework/Store/Data/Products/Handlers/LoadVariantChildren";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import {
    getProductState,
    getVariantChildrenDataView,
} from "@store/Modules/client-framework/src/Store/Data/Products/ProductsSelectors";
import { createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

export const RequestDataFromApi = createChainHandler("RequestDataFromApi", chain, async props => {
    const {
        apiParameter,
        parameter: { searchTerm },
    } = props;
    if (!apiParameter && !searchTerm) {
        return;
    }

    if (apiParameter) {
        props.product = getProductState(props.getState(), apiParameter.id).value;
        if (
            !props.product ||
            !props.product.detail ||
            !props.product.variantTraits // Store Custom Code
        ) {
            if (props.parameter.variantId) {
                props.product = await executeAwaitableHandlerChain(
                    loadVariantChild,
                    props.apiParameter as GetProductVariantChildApiV2Parameter,
                    props,
                );
            } else {
                props.product = await executeAwaitableHandlerChain(loadProduct, props.apiParameter, props);
            }
        }
    } else if (searchTerm) {
        props.product = (
            (await executeAwaitableHandlerChain(
                loadProducts,
                { extendedNames: [searchTerm], expand: ["variantTraits"] },
                props,
            )) as ProductModel[]
        )[0];
    }
});

replaceInChain(chain, BaseRequestDataFromApi, RequestDataFromApi);

export const LoadInventory = createChainHandler("LoadInventory", chain, async props => {
    const product = props.product;
    if (!product) {
        return;
    }
    props.productInfo = createFromProduct(product);

    /* Store Custom Code - Start */
    if (!props.parameter.skipInventoryValidation) {
        let loadedInventory = false;

        props.dispatch(
            loadRealTimeInventory({
                productIds: [product.id],
                onComplete: realTimeInventoryProps => {
                    if (realTimeInventoryProps.error) {
                        if (props.productInfo) {
                            props.productInfo.failedToLoadInventory = true;
                        }
                    } else if (props.productInfo) {
                        props.productInfo.inventory = realTimeInventoryProps.apiResult?.realTimeInventoryResults?.find(
                            o => o.productId === product.id,
                        );
                    }
                    loadedInventory = true;
                },
            }),
        );

        await waitFor(() => loadedInventory);
    }
    /* Store Custom Code - End */
});

replaceInChain(chain, BaseLoadInventory, LoadInventory);

export const RequestVariantChildrenFromApi = createChainHandler("RequestVariantChildrenFromApi", chain, props => {
    if (!props.product?.variantTraits || props.product.variantTraits.length === 0) {
        return;
    }

    props.variantChildren = getVariantChildrenDataView(props.getState(), props.product).value; // Store Custom Code
    if (!props.variantChildren) {
        /* Store Custom Code - Start */
        executeAwaitableHandlerChain(
            loadVariantChildren,
            { productId: props.product.id, product: props.product } as any,
            props,
        );
        /* Store Custom Code - End */
    }
});

replaceInChain(chain, BaseRequestVariantChildrenFromApi, RequestVariantChildrenFromApi);
